import React from "react";
import "./CeoReport.scss";
import ceoImg from "../../../assets/About/rupali-ceo.jpeg";
// import ceoSign from "../../../assets/About/ceo-sign.PNG";
import ceoSign from "../../../assets/About/ceo-sign.png";

const CeoReport = () => {
  return (
    <>
      <div className="ceo_report">
        <div className="container">
          <div className="heading_box">CEO's Round up</div>

          <div className="row">
            <div className="col-lg-8 ">
              <p>
                Ladies and Gentlemen, Esteemed Shareholders, and Valued
                Partners,
                <br />
                <br />
                It is with great honour and optimism that I present to you the
                Annual Report of Rupali Insurance Company Limited for the year
                ending December 31, 2025.
              </p>
              <p>
                <b>Building Confidence, Creating Value</b>
                <br />
                The year 2025 was a period of resilience, adaptation, and steady
                progress for Rupali Insurance Company Limited. Despite a
                challenging economic environment marked by inflationary
                pressures, evolving market conditions, and heightened business
                uncertainties, the Company remained focused on its core
                objectives of sustainable growth, operational excellence, and
                customer service. Through disciplined execution and prudent
                management, we continued to strengthen our market position and
                create value for our stakeholders.
              </p>
              <p>
                <b>Economic and Industry Environment</b>
                <br />
                The global insurance industry continued to evolve in response to
                technological advancements, changing customer expectations, and
                increasingly complex risk landscapes. Digital transformation,
                data-driven decision-making, and enhanced risk management
                practices remained central to the industry's development
                worldwide.
              </p>

              <p>
                In Bangladesh, economic activity gradually gained momentum
                during the year, supported by ongoing industrial and commercial
                growth and improving business confidence. The insurance sector
                continued to play a vital role in supporting economic stability
                by providing financial protection to businesses and individuals.
                Growing awareness of risk management, regulatory developments,
                and the gradual expansion of insurance penetration continued to
                create opportunities for sustainable industry growth.
              </p>
            </div>
            <div className="col-lg-4 text-lg-end text-center order-first order-lg-last">
              <img src={ceoImg} className="img-fluid mb-3" alt="" />
            </div>
          </div>

          <div className="my-3">
            <p>
              <b>Performance Overview</b>
              <br />
              Against this backdrop, Rupali Insurance delivered steady growth in
              its core operations during 2025. The Company achieved a Gross
              Premium Income of BDT 761.71 million, representing a growth of
              13.15% over the previous year, reflecting continued business
              expansion and strong customer confidence.
              <br />
              <br />
              A notable achievement during the year was the significant
              improvement in underwriting performance. Underwriting Profit
              increased to BDT 98.80 million, demonstrating the effectiveness of
              our underwriting discipline, risk selection, and portfolio
              management strategies. This strong operational performance
              reinforces the sustainability of our core insurance business and
              provides a solid foundation for future growth.
              <br />
              <br />
              The Company's Total Assets stood at BDT 2,625.86 million at
              year-end, including investments of BDT 827.27 million and fixed
              assets of BDT 445.25 million. Net Profit Before Tax amounted to
              BDT 77.90 million, reflecting prevailing market conditions and
              investment income dynamics during the year.
              <br />
              <br />
              Our nationwide presence continued to expand with the opening of
              additional branches, bringing our network to 38 branches across
              the country. Supported by a dedicated workforce of 426 employees,
              we remain committed to delivering efficient, reliable, and
              customer-focused insurance services to our valued policyholders.
            </p>

            <p>
              <b>Strengthening Our Foundation</b>
              <br />
              Throughout the year, we remained focused on strengthening the
              Company's institutional framework and operational capabilities. We
              continued to enhance our risk management practices, internal
              control mechanisms, and compliance standards in line with
              regulatory requirements and industry best practices.
              <br />
              <br />
              The year also demonstrated the strength and continuity of our
              organization. Supported by experienced leadership, dedicated
              employees, and a clear strategic direction, the Company
              successfully maintained its focus on long-term objectives while
              adapting to changing market conditions. We continued to invest in
              process improvements and operational efficiencies aimed at
              enhancing service quality, improving responsiveness, and
              supporting sustainable growth.
            </p>

            <p>
              <b>Strategic Outlook</b>
              <br />
              <p>
                Looking ahead, we remain optimistic about the prospects of both
                the insurance industry and the broader economy. Increasing
                industrial activity, expanding commercial opportunities, growing
                awareness of insurance, and continued technological advancement
                are expected to create new avenues for growth in the years
                ahead.
                <br />
                <br />
                Our strategic priorities remain focused on:
              </p>

              <ul>
                <li>
                  Strengthening underwriting discipline and portfolio quality;
                </li>
                <li>
                  Expanding business opportunities across key market segments
                  and emerging economic regions;
                </li>
                <li>
                  Enhancing customer service and claims management capabilities;
                </li>
                <li>
                  Leveraging technology to improve operational efficiency and
                  customer experience; Maintaining strong governance,
                  compliance, and risk management practices; and
                </li>
                <li>
                  Creating sustainable value for shareholders while safeguarding
                  the interests of policyholders.
                </li>
              </ul>
            </p>
            <p>
              As Bangladesh continues its journey toward greater economic
              development, Rupali Insurance remains committed to supporting
              businesses, individuals, and communities through dependable
              insurance solutions and responsible corporate stewardship.
            </p>

            <p>
              <b>Acknowledgement</b>
              <br />
              The achievements of 2025 would not have been possible without the
              collective efforts of our employees, branch offices, agents,
              clients, business partners, and stakeholders. I extend my sincere
              appreciation to the Board of Directors for their guidance and
              support, and to our valued policyholders and shareholders for the
              trust and confidence they continue to place in Rupali Insurance
              Company Limited.
            </p>

            <p>
              I would also like to acknowledge the enduring legacy of the late
              Mr. Mostafa Golam Quddus, whose vision and leadership contributed
              significantly to the growth and reputation of the Company. As we
              move forward, we remain committed to preserving the values and
              principles that have long guided Rupali Insurance.
            </p>

            <p>
              With confidence in our people, strength in our foundation, and
              clarity in our purpose, we look forward to the future with
              optimism and determination. Together, we will continue to build a
              stronger, more resilient, and more prosperous Rupali Insurance
              Company Limited.
            </p>
          </div>

          {/*  */}

          <p>
            Thanking you with
            <br />
            Kindest Regards
          </p>
          <p>
            <b>A. H. M. Abul Khair</b> <br />
            Chief Executive Officer (In-Charge)
          </p>

          {/* <div className="text-lg-end text-center">
            <img src={ceoSign} className="img-fluid" alt="" />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CeoReport;
